import axios from './client'
import { SavedSearchScope, SavedSearchesResponse, SavedSearchResponse } from '../types/savedSearch'

export async function getSavedSearches<F = unknown>(scope: SavedSearchScope = 'releases'): Promise<SavedSearchesResponse<F>> {
  const { data } = await axios.get('/saved-searches', { params: { scope } })
  return data
}

export async function createSavedSearch<F>(name: string, filters: F, scope: SavedSearchScope = 'releases'): Promise<SavedSearchResponse<F>> {
  const { data } = await axios.post('/saved-searches', { name, filters, scope })
  return data
}

export async function updateSavedSearch<F>(id: number, updates: { name?: string; filters?: F }): Promise<SavedSearchResponse<F>> {
  const { data } = await axios.put(`/saved-searches/${id}`, updates)
  return data
}

export async function deleteSavedSearch(id: number): Promise<{ success: boolean }> {
  const { data } = await axios.delete(`/saved-searches/${id}`)
  return data
}
